//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        options: Array,
        selected: [Number, String]
    },
    methods: {
        change (item, index) {
            this.$emit('change', {
                detail: {
                    ...item,
                    index
                }
            })
        }
    }
}
